// @core/api/endpoints/team/revoke_team_ownership.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RevokeTeamOwnershipRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Revoke team ownership
 * Removes ownership privileges from a team member. The team must retain at least one owner.
 */
export async function RevokeTeamOwnership(
  team_id: string,
  data: RevokeTeamOwnershipRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/ownership/revoke`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
